import { DocumentType } from 'src/types/enums';
import { ITabItem, Tabs } from '../../../../components/tabs/Tabs';
import { useResolvedPath } from 'react-router-dom';
import { DocumentTypeNames } from './constants';

const DocumentNoteSettingsPage = () => {
  // The payment reminder letter is no longer assembled from free-text notes:
  // its wording lives in the translation registry so the layout can interpolate
  // the amount, the term and the reference. Its DocumentType values are kept
  // for the existing rows, but there is nothing left to edit here.
  const tabItems: ITabItem[] = [DocumentType.Tro, DocumentType.Planning, DocumentType.Quotation].map((v) => {
    return {
      title: DocumentTypeNames[v],
      path: useResolvedPath(v).pathname,
    };
  });

  return <Tabs items={tabItems} />;
};

export default DocumentNoteSettingsPage;
